import Input from '@mui/material/Input';
import React from 'react';

/**
 * Creates a tax classification input to diaplay the value from netsuite.
 *
 *  @param {object} form the vendor application data
 */
export default function makeTaxClassificationSelectInput(form) {
  return (
    <Input
      name="tax_classification"
      id="va-tax-classification"
      value={form.tax_classification || ''}
    />
  );
}
